import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { useI18n } from '~/app/i18n/i18n';
import { WltpInfo } from '~/app/market-config';
import { RenderHtml } from '~/components/text';
import { useCatalog } from '~/graphql/hooks/use-configurator';
import { breakPoints } from '~/styles/break-points';
import { DATA_TEST_ID } from '~/test/data-test-id';

const StyledSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	max-width: 1248px;

	.section-container {
		display: grid;
		column-gap: 64px;
		row-gap: 8px;
		${breakPoints({
			'768': `grid-template-columns: repeat(2, minmax(0, 1fr))`,
		})};
	}

	.place-self-end {
		place-self: end;
	}

	.mr-auto {
		margin-right: auto;
	}

	.max-w-sm {
		max-width: 350px;
	}
`;

export function EecLabelSectionDefault({ eecURL, wltpInfo }: { eecURL?: string; wltpInfo?: WltpInfo }) {
	const { i18n } = useI18n();
	const { carInfo } = useCatalog();

	const eecRemark = i18n('ngc.technicalData.section.consumptionAndEmission.eecRemark');

	return (
		<StyledSection className="flex flex-col gap-4" data-testid={DATA_TEST_ID.SUMMARY_EEC_CONTAINER}>
			<div>
				<Text variant={{ type: 'copy', order: '2', style: 'bold' }}>
					{i18n('ngc.technicalData.section.consumptionAndEmission.eecTitle')}
				</Text>
				<Text className="mt-4" variant={{ type: 'copy', order: '2', style: 'normal' }}>
					{i18n('ngc.technicalData.section.consumptionAndEmission.eecDisclaimer')}
				</Text>
			</div>
			<div>
				<img
					className="eec-image"
					src={eecURL}
					alt={i18n('ngc.technicalData.section.consumptionAndEmission.eecTitle')}
					aria-label={i18n('ngc.technicalData.section.consumptionAndEmission.eecTitle')}
				/>
			</div>
			{wltpInfo && wltpInfo.showCarModel && (
				<Text variant={{ type: 'copy', order: '2', style: 'bold' }}>{carInfo?.carline}</Text>
			)}

			{eecRemark && (
				<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>
					<RenderHtml html={eecRemark} />
				</Text>
			)}
		</StyledSection>
	);
}
